import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12.05 13.287a.7.7 0 0 1 .7.7v4.576l1.4-1.454a.7.7 0 1 1 1.009.971l-2.604 2.705a.7.7 0 0 1-.999.01L8.851 18.09a.7.7 0 0 1 .99-.99l1.51 1.51v-4.622a.7.7 0 0 1 .7-.7ZM12.058 3a.7.7 0 0 1 .497.215L15.16 5.92a.7.7 0 1 1-1.009.97l-1.4-1.453v4.575a.7.7 0 1 1-1.4 0V5.39L9.84 6.9a.7.7 0 0 1-.99-.99l2.706-2.705A.7.7 0 0 1 12.058 3Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
